import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import Button from 'components/ui/button/button';
import './popup-confirm-cookies.scss';

const PopupConfirmCookies = ({languageId, loginRole, deviceInfo, toggleAcceptCookies, toggleCookiePopup}) => {

	/* Hide / show more info */
	const [showMoreInfo, setShowMoreInfo] = useState(false);
 
	return (
		<div 
			className={'PopupConfirmCookies ' + deviceInfo.orientation + ' ' + loginRole} 
			onClick={() => {toggleCookiePopup();}}
		>
			<div className="PopupConfirmCookies-content">
				<div className="PopupConfirmCookies-text">
					{renderMarkdown(getText('cookies_text1', languageId))}
					{showMoreInfo && renderMarkdown(getText('cookies_text2', languageId))}
				</div>
				<div 
					className="PopupConfirmCookies-textBtn"
					onClick={() => {setShowMoreInfo(!showMoreInfo);}}
				>
					<span>
						{showMoreInfo ? getText('cookies_seeLess', languageId) : getText('cookies_seeMore', languageId)}
					</span>
				</div>
				<div className="PopupConfirmCookies-buttons">
					<div className="PopupConfirmCookies-button yes">
						<Button 
							text={getText('cookies_yes', languageId)} 
							classes={['orange']} 
							onClick={() => {toggleAcceptCookies(true);}} 
						/>
					</div>
					<div className="PopupConfirmCookies-button no">
						<Button 
							text={getText('cookies_no', languageId)} 
							classes={['orange']} 
							onClick={() => {toggleAcceptCookies(false);}} 
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

PopupConfirmCookies.propTypes = {
	languageId: PropTypes.string.isRequired,
	loginRole: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	toggleAcceptCookies: PropTypes.func.isRequired,
	toggleCookiePopup: PropTypes.func.isRequired,
};

export default PopupConfirmCookies;
